export const DOUBLE_TICK_ICON_URL =
  "https://img.icons8.com/ios-filled/50/A3ABA5/double-tick.png";
export const SINGLE_TICK_ICON_URL =
  "https://img.icons8.com/material/24/A3ABA5/checkmark--v1.png";
export const ENQUEUE_ICON_URL =
  "https://img.icons8.com/material-outlined/24/000000/delivery-time.png";
export const DOUBLE_GREEN_TICK_ICON_URL =
  "https://img.icons8.com/?size=100&id=nCNUjT0PGvVH&format=png&color=000000"